export const SET_ORGANAZITION_LIST = 'SET_ORGANAZITION_LIST';
export const SET_ORGANAZITION_TREE = 'SET_ORGANAZITION_TREE';
export const SET_POSITION_LIST = 'SET_POSITION_LIST';
export const SET_ROLE_LIST = 'SET_ROLE_LIST';
export const SET_GRADE_LIST = 'SET_GRADE_LIST';
export const SET_CAMPUS_LIST = 'SET_CAMPUS_LIST';
export const SET_INSITITUTE_LIST = 'SET_INSITITUTE_LIST';
export const SET_MAJOR_LIST = 'SET_MAJOR_LIST';
export const SET_CLAZZ_LIST = 'SET_CLAZZ_LIST';
export const SET_USER_TYPE_LIST = 'SET_USER_TYPE_LIST';
export const SET_LEVEL_LIST = 'SET_LEVEL_LIST';
export const SET_FACULTY_LIST = 'SET_FACULTY_LIST';
export const SET_POSITION_ATTR_LIST = 'SET_POSITION_ATTR_LIST';
export const SET_TAG_LINK_LIST = 'SET_TAG_LINK_LIST';
export const SET_DATASET_LIST = 'SET_DATASET_LIST';
export const SET_MODEL_TYPE_LIST = 'SET_MODEL_TYPE_LIST';
export const SET_MODEL_CHANNEL_LIST = 'SET_MODEL_CHANNEL_LIST';
export const SET_MODEL_SET_LIST = 'SET_MODEL_SET_LIST';
